import styled, {
  css,
} from 'styled-components';


import icon1 from '../../../styles/images/icon-title-1.png';
import icon2 from '../../../styles/images/icon-title-2.png';
import icon3 from '../../../styles/images/icon-title-3.png';
import icon4 from '../../../styles/images/icon-title-4.png';
import icon5 from '../../../styles/images/icon-title-5.png';
import icon6 from '../../../styles/images/icon-title-6.png';
import icon7 from '../../../styles/images/icon-title-7.png';
import icon8 from '../../../styles/images/icon-title-8.png';

const iconStyles = css`
  margin-right: 10px;
  float: left;
  width: 50px;
  height: 50px;
  background-size: cover; 
  background-repeat: no-repeat;

  @media screen and (max-width: 768px){
    float: none;
    width: 80px;
    height: 80px;
    display: block;
    margin: auto;
    background-size: contain;
    margin-bottom: 20px;
  }
`;

const Icon1 = styled.div`
  ${iconStyles}
  background-image: url(${icon1});
`;

const Icon2 = styled.div`
  ${iconStyles}
  background-image: url(${icon2});
`;

const Icon3 = styled.div`
  ${iconStyles}
  background-image: url(${icon3});
`;

const Icon4 = styled.div`
  ${iconStyles}
  background-image: url(${icon4});
`;

const Icon5 = styled.div`
  ${iconStyles}
  background-image: url(${icon5});
`;

const Icon6 = styled.div`
  ${iconStyles}
  background-image: url(${icon6});
`;

const Icon7 = styled.div`
  ${iconStyles}
  background-image: url(${icon7});
`;

const Icon8 = styled.div`
  ${iconStyles}
  background-image: url(${icon8});
`;

const icons = [
  Icon1,
  Icon2,
  Icon3,
  Icon4,
  Icon5,
  Icon6,
  Icon7,
  Icon8,
];


export default icons;



// WEBPACK FOOTER //
// ./src/components/landing/FeatureCarousel/icons.js